import * as actions from 'actions/lineNoteReader'
import { fromJS } from 'immutable'
import { set } from 'utils/immutable'
import { compose } from 'ramda'
import { createReducer } from './utils'

export const LINE_NOTE_REDUX_KEY = 'lineNoteReader'

export const initialState = fromJS({
  searchedLineNoteParts: [],
  searchedLineNoteString: '',
  invalidSearchedNoteParts: [],
  generation: 0,
})

const handlers = {
  [actions.SUCCESS_SEARCHED_LINE_NOTE]: lineNoteReaderParts,
  [actions.CLEAR_LINE_NOTE_READER]: (state) =>
    initialState.set('generation', state.get('generation') + 1),
}

export default createReducer(initialState, handlers)

function lineNoteReaderParts(state, { searchedString, generation, data = [] }) {
  if (generation !== undefined && generation !== state.get('generation'))
    return state
  const { validNoteEntry, invalidNoteEntry } = data.reduce(
    (acc, curr) => {
      const { isInvalidLineNote } = curr
      if (!isInvalidLineNote)
        return {
          ...acc,
          validNoteEntry: [...acc.validNoteEntry, curr],
        }

      return {
        ...acc,
        invalidNoteEntry: [...acc.invalidNoteEntry, curr],
      }
    },
    {
      validNoteEntry: [],
      invalidNoteEntry: [],
    }
  )
  const transform = compose(
    set('searchedLineNoteParts', validNoteEntry),
    set('invalidSearchedNoteParts', invalidNoteEntry),
    set('searchedLineNoteString', searchedString)
  )
  return transform(state)
}
